import React from "react";
import "./TalkCard.scss";
import hemang from "../../assets/images/hemang.jpg"

export default function TalkCard({ talkDetails }) {
  return (
    <div className="talk-card">
      <div className="talk-card-container">
        <div
          className={
            talkDetails.isDark ? "talk-card-rectangle dark-rectangle" : "talk-card-rectangle"
          }
        >
          <div className="talk-card-diagonal-fill"></div>
          <div className="talk-card-content">
            <div className="talk-card-title">{talkDetails.title}</div>
            <p className="talk-card-subtitle">{talkDetails.subtitle}</p>
            <img src={hemang}></img>
            {/* <div className="talk-card-buttons">
              <a href={talkDetails.slides_url} target="_blank" className="talk-card-button">
                Slides
              </a>
              <a href={talkDetails.event_url} target="_blank" className="talk-card-button">
                Event
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}